import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { toast } from 'sonner';
import { chatService, type FileUploadResponse } from '@/lib/api/services/chat.service';

export function useChatUpload() {
  const { getToken } = useAuth();

  const uploadMutation = useMutation({
    mutationFn: async ({
      file,
      conversationId,
    }: {
      file: File;
      conversationId?: string;
    }): Promise<FileUploadResponse> => {
      const token = await getToken();
      return await chatService.uploadFile(file, async () => token, conversationId);
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to upload file');
      console.error('Error uploading file:', error);
    },
  });

  return {
    uploadFile: uploadMutation.mutateAsync,
    isUploading: uploadMutation.isPending,
    uploadError: uploadMutation.error,
  };
}
